// extracted by mini-css-extract-plugin
export var dropdownButton = "_20-0";
export var fullWidthDropdownButton = "_20-1";
export var icon = "_20-3";
export var iconPlaceholder = "_20-2";
export var menuItemRow = "_20-8";
export var separator = "_20-c";
export var shortcutContainer = "_20-7";
export var shortcutIconLg = "_20-6";
export var shortcutIconMd = "_20-5";
export var shortcutIconSm = "_20-4";
export var submenuChevron = "_20-b";
export var submenuDropdown = "_20-9";
export var submenuTriggerRow = "_20-a";